module.exports = __webpack_public_path__ + "static/media/start-button.ac3776ed.png";